import React from 'react';
import styled from 'styled-components';
import { SkilletIcon } from '../card/card-icon';
const WrapIconSkillet = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 24px;
  height: 100vh;
`;
const WrapContent = styled.div `
  min-width: 176px;
  min-height: 176px;
  border-radius: 50%;
  gap: 24px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const NoItemOders = () => {
    return (React.createElement(WrapIconSkillet, { className: 'm-t-5' },
        React.createElement(WrapContent, null,
            React.createElement("div", null,
                React.createElement(SkilletIcon, null)),
            React.createElement("p", null, "No orders found"))));
};
//# sourceMappingURL=index.js.map